export default "__VITE_ASSET__C_a6vlxR__"